import React, {useEffect, useRef} from "react";
import useEmailMessage from "./useEmailMessage";

import Page from "../../layouts/Main/Page";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";


const EmailViewerPage = (props) => {
    const {emailMessageId, onClose, title} = props;
    const {isLoadingEmail, emailMessage, loadEmailMessage} = useEmailMessage();
    const iframeRef = useRef();

    const [expand, setExpand] = React.useState(false);

    const handleIframeLoad = () => {
        iframeRef.current.style.height = iframeRef.current.contentWindow.document.body.scrollHeight + 'px';
        setExpand(true);
    }

    useEffect(
        () => {
            loadEmailMessage(emailMessageId);
        },
        [emailMessageId]  // eslint-disable-line react-hooks/exhaustive-deps
    )

    return <Page title={title}
                 disablePadding
                 onBack={onClose}
                 overlay
                 isLoading={isLoadingEmail}
                 >
        <Container maxWidth="md" sx={{height: "100%"}}>
            <Stack sx={{pt: 1, height: "100%", mb: 8}} spacing={1}>
                <Typography variant="h6" textAlign="center">
                    (Email)
                </Typography>

                <Box boxShadow={2} sx={{minHeight: "200px"}}>
                    <Collapse in={expand} timeout={500}>
                        <iframe ref={iframeRef}
                                title="template-viewer"
                                scrolling="no"
                                srcDoc={emailMessage?.body}
                                width={"100%"}
                                frameBorder="0"
                                onLoad={handleIframeLoad}
                        />
                    </Collapse>
                </Box>
            </Stack>
        </Container>
    </Page>
}

export default EmailViewerPage;
